import { FOLDER_COST } from "../../constants";
import { ItemFactory } from "../dto/item/ItemFactory";
import RemoveFromCartEvent from "./RemoveFromCartEvent";
import { getModePrice } from '../../utilities';
export default class RemoveFromFolderCostNormalizer {
    normalize(elements, origin) {
        const removeFromCartEvent = new RemoveFromCartEvent();
        const gaDivs = $(elements)
            .closest(':has(.ga)')
            .find(".ga");
        $(gaDivs).each(function (index, gaDiv) {
            const item = ItemFactory.createFromDataAttribute($(gaDiv));
            item.index = index + 1;
            item.itemPricing = getModePrice();
            removeFromCartEvent.itemCollection.addItem(item);
        });
        return removeFromCartEvent;
    }
    support(element, origin) {
        return FOLDER_COST === origin;
    }
}
